<div
    class="cmps-scorecard-widget--header"
    role="heading"
>
    {{ _i18n._9398_SCORECARD_SUMMARY | translate }}
</div>

<div>
    <button
        class="cmps-button--no-bg p-0"
        [class.cmps-button--hover]="state?.showScorecardDetail"
        cmpsButton
        (click)="_onToggleScorecardDetail()"
    >
        <cmps-icon
            [svgIcon]="state?.showScorecardDetail ? 'eye-off' : 'eye'"
        ></cmps-icon>
        <span cmpsButtonLabel>
            {{
                (state?.showScorecardDetail
                    ? _i18n._9400_HIDE_SCORECARD_DETAIL
                    : _i18n._9399_SEE_SCORECARD_DETAIL
                ) | translate
            }}
        </span>
    </button>
</div>

<cmps-sw-detail
    [user]="state?.user"
    [scorecard]="state?.selectedScorecard"
    [historyPosition]="state?.historyPos"
    [periodTypes]="state?.periodTypes"
    [selectedPeriodType]="state?.selectedPeriodType?.periodTypeId"
    (userSelect)="_onUserSelect($event)"
    (navigate)="_onNavigate($event)"
    (onPeriodTypeChange)="_onPeriodTypeChange($event)"
    (onPeriodTypeFocus)="_onPeriodTypeFocus()"
    *ngIf="state?.showScorecardDetail"
></cmps-sw-detail>

<ng-container #ref></ng-container>

<div
    class="pulse-widget--expand-your-team"
    *ngIf="
        state?.yourTeamEnabled &&
        state?.selectedScorecard?.data?.roster?.length > 2
    "
>
    <div class="expand-your-team--separator">
        <button
            class="cmps-icon-button cmps-icon-button--no-bg p-0"
            cmpsIconButton
            (click)="_onExpandYourTeamClick()"
        >
            <cmps-icon
                class="expand-your-team--icon"
                [svgIcon]="
                    state?.yourTeamExpanded ? 'chevron-up' : 'chevron-down'
                "
            ></cmps-icon>
        </button>
    </div>
    <div class="d-flex justify-content-center pt-1 expand-your-team--lbl">
        {{
            (state?.yourTeamExpanded
                ? _i18n._9407_SHOW_LESS
                : _i18n._9408_SHOW_MORE
            ) | translate
        }}
    </div>
</div>
